import React from 'react';
import AttendanceTimes from '../shared/AttendanceTimes';
import { Form, Alert } from '../../ui-kit';
import RankSelector from '../../general/RankSelector';
import { IconTriangleExclamation } from '../../ui-kit/icons';

const Link = ({ url, label }) => (
  <a href={url} target="_blank" rel="noreferrer">
    {label}
  </a>
);

export const attendanceTimesColumn = didAttend => ({
  Header: `${I18n.t('attributes.start_time')} - ${I18n.t('attributes.end_time')}`,
  id: 'attendanceTimes',
  filterable: false,
  className: 'column-datepicker',
  minWidth: 150,
  Cell: row => {
    const { attendance, currentReportStartTime, currentReportEndTime, saveAttendance, overlappingAttendances } =
      row.original;
    return (
      <>
        {didAttend(attendance) && (
          <AttendanceTimes
            currentReportStartTime={currentReportStartTime}
            currentReportEndTime={currentReportEndTime}
            attendance={attendance}
            saveAttendance={saveAttendance}
          />
        )}{' '}
        {overlappingAttendances.length > 0 && (
          <Alert variant="danger" className="d-inline p-1" title={I18n.t('activity_reports.overlapping_attendances')}>
            <IconTriangleExclamation /> {overlappingAttendances.length}
          </Alert>
        )}
      </>
    );
  }
});

export const userColumn = maxWidth => ({
  Header: I18n.t('activerecord.models.user'),
  accessor: d => d.user && `${d.user.first_name} ${d.user.last_name}`,
  id: 'userName',
  maxWidth,
  Cell: row => {
    const { user } = row.original;
    return <Link url={user && `/users/${user.id}`} label={row.value} />;
  }
});

export const groupColumn = maxWidth => ({
  Header: I18n.t('activerecord.models.group'),
  accessor: d => d.group.name,
  id: 'groupName',
  maxWidth: maxWidth,
  filterMethod: (filter, row) => {
    const data = row._original;
    // always show known attendances
    return filter.value ? data.attendance.reported_status !== 'unknown' || data.group.id === data.currentGroupId : true;
  },
  Filter: ({ filter, onChange }) => (
    <Form.Check
      id="show_current_group_only"
      onChange={event => onChange(event.target.checked)}
      checked={filter?.value}
      label={I18n.t('activity_reports.show_current_group_only')}
    />
  ),
  Cell: row => {
    const data = row.original;
    return <Link url={`/groups/${data.group.id}`} label={row.value} />;
  }
});

export const rankColumn = didAttend => ({
  Header: I18n.t('activerecord.models.rank'),
  id: 'performedRank',
  maxWidth: 300,
  filterable: false,
  className: 'rank-picker',
  Cell: row => {
    const { attendance, eligibleRanks, saveAttendance } = row.original;
    const performedRank = attendance.performed_rank_id;
    return (
      didAttend(attendance) && (
        <RankSelector
          ranks={eligibleRanks}
          selectedRank={performedRank}
          inputName="performed_rank_id"
          handleChange={event =>
            saveAttendance(attendance.id, {
              performed_rank_id: event.value
            })
          }
        />
      )
    );
  }
});
